import { Dispatch, SetStateAction } from "react";

import { CartItemAddon } from "@swiggy-private/dls-web-recipe-common-web/dist/components/FoodItem/types";
import { ILocalCart, ITableConfig } from "@swiggy-private/portal-dineout-context";

export type PlaceOrderParams = ITableConfig & { covers?: number };

export interface UpdateCartHelperFn {
    isCartUpdating: boolean;
    setShowOverlay: Dispatch<SetStateAction<boolean>>;
    setIsCartEmpty: (isCartEmpty: boolean) => void;
    setUpdatingItemId: (id: string) => void;
    updateCart: (payload: Record<string, unknown>) => Promise<void>;
    callbacks?: {
        onSuccess?: VoidFunction;
        onError?: VoidFunction;
    };
}

export interface UpdateCartWithActionOptions {
    updateLogic: (cartItems?: CartItem[]) => CartItem[];
    helperFn: UpdateCartHelperFn;
    updatedDishItems?: CartItem[];
    updateLocalCartInNative?: (cartData: ILocalCart) => void;
    clearLocalCartInNative?: VoidFunction;
}

export interface CartItemAddonChoice {
    id?: string;
    name?: string;
}

export interface CartItemAddonGroup {
    groupId?: string;
    choices?: CartItemAddonChoice[];
}

export interface CartItemVariantGroup {
    groupId?: string;
    variations?: { id?: string; name?: string }[];
}

export interface CartItemFlatAddon {
    choice_id?: string | number;
    choiceId?: string | number;
    group_id?: string | number;
    groupId?: string | number;
    name?: string;
}

export interface CartItem {
    unId?: string;
    id?: string;
    name?: string;
    menu_item_id?: string;
    menu_item_uuid?: string;
    quantity?: number;
    info?: { id?: string; name?: string };
    addons?: CartItemAddonGroup[] | CartItemFlatAddon[];
    variants?: { group_id?: string; variation_id?: string; name?: string }[];
    variantsV2?: { variantGroups?: CartItemVariantGroup[] };
    selectedInfo?: {
        quantity?: {
            value?: number;
        };
        addons?: CartItemAddonGroup[];
        variantsV2?: { variantGroups?: CartItemVariantGroup[] };
    };
    item_instructions?: {
        special_instructions?: string;
    };
    userInstruction?: {
        textContainer?: {
            text?: {
                info?: string;
            };
        };
    };
}

export interface CartCtaAdditionalInfoValue {
    isChildOrderExist?: boolean | null;
}

export interface CartCtaAdditionalInfo {
    "@type"?: string;
    value?: CartCtaAdditionalInfoValue;
}

export interface CartActionExtraParams {
    action?: string;
    type?: string;
    item?: CartItem;
    newItem?: CartItem;
    isDecrement?: boolean;
    setUpdatingItemId?: Dispatch<SetStateAction<string | null>>;
    updatedDishItems?: CartItem[];
    cookingRequestValue?: string;
    cta?: { link: string; additionalInfo?: CartCtaAdditionalInfo };
    itemInfo?: { id?: string; name?: string };
}

export interface CartUpdateOptions {
    isCartUpdating: boolean;
    setShowOverlay: Dispatch<SetStateAction<boolean>>;
    setIsCartEmpty: (isCartEmpty: boolean) => void;
    setUpdatingItemId: (id: string) => void;
    updateCart: (payload: Record<string, unknown>) => Promise<void>;
    updateLocalCartInNative?: (cartData: ILocalCart) => void;
    clearLocalCartInNative?: VoidFunction;
}

export interface PersistLocalCartOptions {
    updateLocalCartInNative: (cartData: ILocalCart) => void;
    clearLocalCartInNative: () => void;
    refreshMenuInNative: () => void;
}

export enum InstructionActionType {
    ADD = "add",
    SAVE = "save",
    REMOVE = "remove",
}

export interface HandleInstructionsParams {
    action: InstructionActionType;
    cookingRequestValue?: string;
}

export enum TabType {
    CART = "cart",
    ORDERS = "orders",
}

export type CartItemAddonWithName = CartItemAddon & { name: string };
